import { __assign } from '../../external/tslib/tslib.es6.mjs.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import styles from './Switch.module.scss.js';

var toggleActivationKeys = ['Enter', 'Space', 'Spacebar', ' '];
var Switch = function (_a) {
    var _b, _c;
    var id = _a.id, name = _a.name, label = _a.label, inputProps = _a.inputProps, disabled = _a.disabled, className = _a.className, style = _a.style, _d = _a.size, size = _d === void 0 ? 'l' : _d, description = _a.description, ariaLabelledBy = _a["aria-labelledby"], ariaDescribedBy = _a["aria-describedby"];
    var handleChange = function () {
        var _a;
        if (disabled) {
            (_a = inputProps.onDisabledClick) === null || _a === void 0 ? void 0 : _a.call(inputProps);
        }
        else {
            inputProps.onChange(!inputProps.checked);
        }
    };
    var handleKeyDown = function (e) {
        if (toggleActivationKeys.includes(e.key)) {
            e.preventDefault();
            handleChange();
        }
    };
    return (jsxs("div", __assign({ className: clsx(styles.switchWrapper, (_b = {},
            _b[styles.disabled] = disabled,
            _b[styles.small] = size === 's',
            _b[styles.medium] = size === 'm',
            _b), className) }, { children: [jsxs("div", __assign({ className: styles.withLabel, role: "checkbox", "aria-labelledby": ariaLabelledBy || id || name, "aria-describedby": ariaDescribedBy || description ? "".concat(name, "-desc") : undefined, tabIndex: disabled ? -1 : 0, "aria-checked": inputProps.checked, "aria-disabled": disabled, style: style, onClick: handleChange, onKeyDown: handleKeyDown, onBlur: inputProps.onBlur, onFocus: inputProps.onFocus, "data-testid": "switch" }, { children: [jsx("div", { className: clsx(styles.switch, (_c = {},
                            _c[styles.switch__checked] = inputProps.checked,
                            _c[styles.switch__disabled] = disabled,
                            _c)) }), label && (jsx("p", __assign({ className: styles.label, id: id || name }, { children: label })))] })), description && (jsx("p", __assign({ className: styles.description, id: "".concat(name, "-desc") }, { children: description })))] })));
};

export { Switch };
